module.exports = __webpack_public_path__ + "i18n/zh-TW.596ff126ca788f0e6f0b0dde18a78c66.json";